export default __webpack_public_path__ + "static/media/cards_thumb.e670ed86.jpg";